import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  NAMESPACES,
  DEFAULT_NAMESPACE,
} from "./config";
import { useLocaleStore } from "../store/localeStore";

// Language switching disabled — force Spanish until translations are reviewed.
// To re-enable, restore getPersistedLocale() and the LanguageSwitcher component.

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    defaultNS: DEFAULT_NAMESPACE,
    ns: NAMESPACES,
    backend: {
      // CRITICAL: absolute path — relative ./locales/ breaks with HashRouter
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

// Mientras el cambio de idioma esta deshabilitado (UI forzada a espanol arriba),
// sincronizamos el store de locale al idioma por defecto. Asi `getLocale()` —que
// alimenta el header Accept-Language en apiFetch— nunca arrastra un 'en' rancio
// persistido y el contenido localizado por backend (p.ej. categorias de escenas)
// vuelve en espanol, coherente con la UI. Quitar al re-habilitar el switch.
try {
  if (useLocaleStore.getState().locale !== DEFAULT_LANGUAGE) {
    useLocaleStore.getState().setLocale(DEFAULT_LANGUAGE);
  }
} catch (_e) {
  // no rompemos el arranque si el store no esta disponible
}

export default i18n;
